import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import LockedPasswordPanelActions from './actions';

const initialState = Immutable({
  email: '',
});

export default createReducer(on => {
  on(LockedPasswordPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
